import React, { useEffect, useState } from "react";
import { fetchServices, createService, updateService, deleteService, getCurrency, bookService, fetchReservations, fetchMembers } from "../services/api";
import { formatPrice } from "../utils/currency";
import { useT } from "../i18n/useT";

// Services & Memberships — service catalog (SM0). Generic priced services per
// area (spa / gym / pool / salon / activities). Booking + billing arrive in SM1.
const S = {
  en: {
    title: "Services", subtitle: "Spa, gym, pool and other bookable services",
    all: "All", spa: "Spa", gym: "Gym", pool: "Pool", salon: "Salon", activity: "Activities",
    add: "Add service", edit: "Edit service", name: "Service name", area: "Area",
    duration: "Duration (min)", dur_hint: "leave blank for access (no fixed time)",
    p_public: "Public price", p_guest: "Guest price", p_member: "Member price",
    tier_hint: "leave guest/member blank to use the public price",
    needs_res: "Needs a therapist / room",
    needs_staff: "Needs staff / provider", staff_title: "Staff title",
    staff_ph: "Therapist, Trainer, Hairdresser", needs_room: "Needs a room",
    options: "Options", options_ph: "One option per line (e.g. Gel, Regular, French)",
    options_hint: "guests pick from these when booking",
    special_request: "Special request", sr_ph: "Any request or note (optional)",
    save: "Save", cancel: "Cancel",
    none: "No services yet — add your first one above.", del: "Delete", del_q: "Delete this service?",
    inactive: "inactive", min: "min", access: "access",
    sell: "Sell / book", bt_guest: "In-house guest", bt_walkin: "Walk-in", bt_member: "Member",
    pick_guest: "Choose guest", pick_member: "Choose member", no_members: "No active members yet.",
    search_room_or_name: "Search room # or guest name",
    covered: "Covered by membership.", no_inhouse: "No in-house or booked guests right now.",
    cust_name: "Customer name (optional)", cust_phone: "Phone (optional)", pay_method: "Payment",
    cust_company: "Company (optional)", cust_tin: "TIN (optional)",
    m_cash: "Cash", m_telebirr: "telebirr", m_cbe: "CBE Birr", m_pos: "POS card",
    book_now: "Confirm", added_folio: "Added to {g}'s room bill.", receipt: "Receipt",
    r_service: "Service charge", r_vat: "VAT", r_total: "Total", print: "Print", close_l: "Close",
  },
  am: {
    title: "አገልግሎቶች", subtitle: "ስፓ፣ ጂም፣ መዋኛ እና ሌሎች የሚያዙ አገልግሎቶች",
    all: "ሁሉም", spa: "ስፓ", gym: "ጂም", pool: "መዋኛ", salon: "ሳሎን", activity: "እንቅስቃሴዎች",
    add: "አገልግሎት ጨምር", edit: "አገልግሎት አስተካክል", name: "የአገልግሎት ስም", area: "ዘርፍ",
    duration: "ቆይታ (ደቂቃ)", dur_hint: "ለመግቢያ ባዶ ይተዉ",
    p_public: "የህዝብ ዋጋ", p_guest: "የእንግዳ ዋጋ", p_member: "የአባል ዋጋ",
    tier_hint: "የእንግዳ/አባል ባዶ ከሆነ የህዝብ ዋጋ ይጠቀማል",
    needs_res: "ቴራፒስት / ክፍል ይፈልጋል",
    needs_staff: "ሰራተኛ / አገልጋይ ይፈልጋል", staff_title: "የሰራተኛ ማዕረግ",
    staff_ph: "ቴራፒስት፣ አሰልጣኝ፣ ፀጉር አስተካካይ", needs_room: "ክፍል ይፈልጋል",
    options: "አማራጮች", options_ph: "በእያንዳንዱ መስመር አንድ አማራጭ", // TODO verify am
    options_hint: "እንግዶች ሲይዙ ከእነዚህ ይመርጣሉ", // TODO verify am
    special_request: "ልዩ ጥያቄ", sr_ph: "ማንኛውም ጥያቄ ወይም ማስታወሻ (አማራጭ)", // TODO verify am
    save: "አስቀምጥ", cancel: "ሰርዝ",
    none: "እስካሁን አገልግሎት የለም — ከላይ ይጨምሩ።", del: "ሰርዝ", del_q: "ይህን አገልግሎት ይሰረዝ?",
    inactive: "ገቢር አይደለም", min: "ደቂቃ", access: "መግቢያ",
    sell: "ሽጥ / ያዝ", bt_guest: "የቤት ውስጥ እንግዳ", bt_walkin: "መጤ ደንበኛ", bt_member: "አባል",
    pick_guest: "እንግዳ ይምረጡ", pick_member: "አባል ይምረጡ", no_members: "ገቢር አባል የለም።",
    search_room_or_name: "የክፍል # ወይም የእንግዳ ስም ይፈልጉ",
    covered: "በአባልነት ተሸፍኗል።", no_inhouse: "አሁን የቤት ውስጥ ወይም የተያዘ እንግዳ የለም።",
    cust_name: "የደንበኛ ስም (አማራጭ)", cust_phone: "ስልክ (አማራጭ)", pay_method: "ክፍያ",
    cust_company: "ድርጅት (አማራጭ)", cust_tin: "ቲን (አማራጭ)",
    m_cash: "ጥሬ ገንዘብ", m_telebirr: "ቴሌብር", m_cbe: "ሲቢኢ ብር", m_pos: "ፖስ ካርድ",
    book_now: "አረጋግጥ", added_folio: "ወደ {g} የክፍል ሂሳብ ተጨመረ።", receipt: "ደረሰኝ",
    r_service: "የአገልግሎት ክፍያ", r_vat: "ተ.እ.ታ", r_total: "ጠቅላላ", print: "አትም", close_l: "ዝጋ",
  },
  om: {
    title: "Tajaajiloota", subtitle: "Spaa, jiimii, daakaa fi tajaajila qabamuu danda'an",
    all: "Hunda", spa: "Spaa", gym: "Jiimii", pool: "Daakaa", salon: "Saaloonii", activity: "Sochiiwwan",
    add: "Tajaajila dabali", edit: "Tajaajila sirreessi", name: "Maqaa tajaajilaa", area: "Naannoo",
    duration: "Turtii (daq.)", dur_hint: "seensaaf duwwaa dhiisi",
    p_public: "Gatii uummataa", p_guest: "Gatii keessummaa", p_member: "Gatii miseensaa",
    tier_hint: "keessummaa/miseensa duwwaa yoo ta'e gatii uummataa fayyadama",
    needs_res: "Terapistii / kutaa barbaada",
    needs_staff: "Hojjetaa / kennaa barbaada", staff_title: "Sadarkaa hojjetaa",
    staff_ph: "Terapistii, Leenjisaa, Rifeensa qaphxaa", needs_room: "Kutaa barbaada",
    options: "Filannoowwan", options_ph: "Sarara tokkoon filannoo tokko", // TODO verify om
    options_hint: "keessummoonni yeroo qaban kanneen keessaa filatu", // TODO verify om
    special_request: "Gaaffii addaa", sr_ph: "Gaaffii yookaan yaadannoo kamiyyuu (filannoo)", // TODO verify om
    save: "Olkaa'i", cancel: "Haqi",
    none: "Hanga ammaa tajaajilli hin jiru — olitti dabali.", del: "Haqi", del_q: "Tajaajila kana haquu?",
    inactive: "hin hojjetu", min: "daq", access: "seensa",
    sell: "Gurguri / qabi", bt_guest: "Keessummaa mana keessaa", bt_walkin: "Nama dhufe", bt_member: "Miseensa",
    pick_guest: "Keessummaa fili", pick_member: "Miseensa fili", no_members: "Miseensi hojjetu hin jiru.",
    search_room_or_name: "Lakk. kutaa yookaan maqaa keessummaa barbaadi",
    covered: "Miseensummaadhaan haguugame.", no_inhouse: "Yeroo ammaa keessummaan mana keessaa hin jiru.",
    cust_name: "Maqaa maamilaa (filannoo)", cust_phone: "Bilbila (filannoo)", pay_method: "Kaffaltii",
    cust_company: "Dhaabbata (filannoo)", cust_tin: "TIN (filannoo)",
    m_cash: "Maallaqa", m_telebirr: "telebirr", m_cbe: "CBE Birr", m_pos: "Kaardii POS",
    book_now: "Mirkaneessi", added_folio: "Gara herrega kutaa {g} dabalame.", receipt: "Nagahee",
    r_service: "Kaffaltii tajaajilaa", r_vat: "VAT", r_total: "Ida'ama", print: "Maxxansi", close_l: "Cufi",
  },
};

const AREAS = ["spa", "gym", "pool", "salon", "activity"];
const CARD = { background: "#fff", border: "1px solid #eef2f2", borderRadius: 14, boxShadow: "0 1px 3px rgba(6,59,72,0.06)" };
const inp = { padding: "9px 10px", border: "1px solid #d8dee2", borderRadius: 8, fontSize: 14 };
const AREA_TINT = { spa: "#EAF3F0", gym: "#EEF2FB", pool: "#EAF6FC", salon: "#FBEFF4", activity: "#FBF5E8" };
const AREA_FG = { spa: "#0F6E56", gym: "#3C3489", pool: "#0077b3", salon: "#A33C6B", activity: "#8A5A0B" };

const EMPTY = { area: "spa", name: "", duration_min: "", price_public: "", price_guest: "", price_member: "", needs_resource: false, needs_staff: false, needs_room: false, staff_title: "", options: "" };

// Options are stored as a JSON array on the service; the manager edits them as a
// newline/comma list. These helpers convert between the two.
const optionsToText = (arr) => (Array.isArray(arr) ? arr.join("\n") : "");
const textToOptions = (txt) => (txt || "").split(/[\n,]/).map((o) => o.trim()).filter(Boolean);

export default function ServicesPage({ embedded = false }) {
  const { lang } = useT();
  const t = (k) => (S[lang] && S[lang][k]) || S.en[k] || k;
  const cur = getCurrency() || "ETB";
  const [rows, setRows] = useState(null);
  const [filter, setFilter] = useState("all");
  const [form, setForm] = useState(EMPTY);
  const [editId, setEditId] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => fetchServices().then(setRows).catch(() => setRows([]));
  useEffect(() => { load(); }, []);

  const startEdit = (s) => {
    setEditId(s.id);
    setForm({
      area: s.area, name: s.name, duration_min: s.duration_min ?? "",
      price_public: s.price_public ?? "", price_guest: s.price_guest ?? "",
      price_member: s.price_member ?? "", needs_resource: !!s.needs_resource,
      needs_staff: !!s.needs_staff, needs_room: !!s.needs_room, staff_title: s.staff_title ?? "",
      options: optionsToText(s.options),
    });
    window.scrollTo(0, 0);
  };
  const reset = () => { setEditId(null); setForm(EMPTY); };
  const num = (v) => (v === "" || v === null ? null : Number(v));

  const save = () => {
    if (!form.name.trim()) return;
    setBusy(true);
    const body = {
      area: form.area, name: form.name.trim(),
      duration_min: form.duration_min === "" ? null : Number(form.duration_min),
      price_public: Number(form.price_public || 0),
      price_guest: num(form.price_guest), price_member: num(form.price_member),
      needs_resource: !!form.needs_resource,
      needs_staff: !!form.needs_staff, needs_room: !!form.needs_room,
      staff_title: form.staff_title.trim() || null,
      options: textToOptions(form.options),
    };
    const p = editId ? updateService(editId, body) : createService(body);
    p.then(() => { reset(); load(); }).catch(() => {}).finally(() => setBusy(false));
  };
  const remove = (s) => { if (window.confirm(t("del_q"))) deleteService(s.id).then(load).catch(load); };

  // SM1 — sell / book a service (in-house guest -> folio, walk-in -> pay now)
  const [bookFor, setBookFor] = useState(null);
  const [bt, setBt] = useState("guest");
  const [resList, setResList] = useState(null);
  const [resId, setResId] = useState("");
  const [gq, setGq] = useState("");     // in-house guest search (room # or name)
  const [memList, setMemList] = useState(null);
  const [memId, setMemId] = useState("");
  const [cName, setCName] = useState("");
  const [cPhone, setCPhone] = useState("");
  const [cCompany, setCCompany] = useState("");   // buyer company (optional, for TIN invoice)
  const [cTin, setCTin] = useState("");           // buyer TIN (optional)
  const [method, setMethod] = useState("cash");
  const [receipt, setReceipt] = useState(null);
  const [flash, setFlash] = useState("");
  const [bookBusy, setBookBusy] = useState(false);
  const [selItems, setSelItems] = useState([]);   // N7: chosen service options
  const [specialReq, setSpecialReq] = useState(""); // N7: free-text special request

  const openBook = (s) => {
    setBookFor(s.id); setBt("guest"); setResId(""); setGq(""); setMemId(""); setCName(""); setCPhone("");
    setCCompany(""); setCTin("");
    setMethod("cash"); setReceipt(null); setFlash(""); setSelItems([]); setSpecialReq("");
    if (resList == null) {
      fetchReservations("all")
        .then((rs) => setResList((rs || []).filter((r) => r.status === "booked" || r.status === "checked_in")))
        .catch(() => setResList([]));
    }
    if (memList == null) {
      fetchMembers().then((ms) => setMemList((ms || []).filter((m) => m.active))).catch(() => setMemList([]));
    }
  };
  const doBook = (s) => {
    if (bt === "guest" && !resId) return;
    if (bt === "member" && !memId) return;
    setBookBusy(true);
    let body;
    if (bt === "guest") body = { customer_type: "guest", reservation_id: Number(resId) };
    else if (bt === "member") body = { customer_type: "member", member_id: Number(memId) };
    else body = { customer_type: "walkin", customer_name: cName.trim() || null, customer_phone: cPhone.trim() || null, payment_method: method, company_name: cCompany.trim() || null, tin: cTin.trim() || null };
    body.selected_items = selItems;
    body.special_request = specialReq.trim() || null;
    bookService(s.id, body).then((d) => {
      if (d.posted_to_folio) {
        const g = (resList || []).find((r) => String(r.id) === String(resId));
        setFlash(t("added_folio").replace("{g}", (g && g.guest_name) || "")); setReceipt(null);
      } else if (d.covered_by_membership) {
        setFlash(t("covered")); setReceipt(null);
      } else {
        setReceipt(d.receipt || null); setFlash("");
      }
    }).catch(() => setFlash("—")).finally(() => setBookBusy(false));
  };
  const priceFor = (s) => {
    if (bt === "guest") return s.price_guest != null ? s.price_guest : s.price_public;
    if (bt === "member") return s.price_member != null ? s.price_member : s.price_public;
    return s.price_public;
  };
  const printReceipt = () => window.print();

  const shown = (rows || []).filter((s) => filter === "all" || s.area === filter);

  return (
    <div style={{ maxWidth: 900, margin: "0 auto" }}>
      {/* When embedded inside the merged Services page the wrapper renders the
          "Services" header + tabs, so we suppress this page's own title/subtitle. */}
      {!embedded && (
        <>
          <h1 style={{ marginBottom: 2 }}>{t("title")}</h1>
          <div className="muted" style={{ fontSize: 14 }}>{t("subtitle")}</div>
        </>
      )}

      {/* add / edit form */}
      <div style={{ ...CARD, padding: 16, marginTop: embedded ? 0 : 16 }}>
        <div style={{ fontWeight: 700, marginBottom: 10 }}>{editId ? t("edit") : t("add")}</div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 10 }}>
          <div>
            <label className="muted" style={{ fontSize: 12 }}>{t("area")}</label>
            <select style={{ ...inp, width: "100%" }} value={form.area} onChange={(e) => setForm({ ...form, area: e.target.value })}>
              {AREAS.map((a) => <option key={a} value={a}>{t(a)}</option>)}
            </select>
          </div>
          <div style={{ gridColumn: "span 2" }}>
            <label className="muted" style={{ fontSize: 12 }}>{t("name")}</label>
            <input style={{ ...inp, width: "100%" }} value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          </div>
          <div>
            <label className="muted" style={{ fontSize: 12 }}>{t("duration")}</label>
            <input style={{ ...inp, width: "100%" }} type="number" min="0" value={form.duration_min} onChange={(e) => setForm({ ...form, duration_min: e.target.value })} />
          </div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 10, marginTop: 10 }}>
          <div>
            <label className="muted" style={{ fontSize: 12 }}>{t("p_public")}</label>
            <input style={{ ...inp, width: "100%" }} type="number" min="0" value={form.price_public} onChange={(e) => setForm({ ...form, price_public: e.target.value })} />
          </div>
          <div>
            <label className="muted" style={{ fontSize: 12 }}>{t("p_guest")}</label>
            <input style={{ ...inp, width: "100%" }} type="number" min="0" value={form.price_guest} onChange={(e) => setForm({ ...form, price_guest: e.target.value })} />
          </div>
          <div>
            <label className="muted" style={{ fontSize: 12 }}>{t("p_member")}</label>
            <input style={{ ...inp, width: "100%" }} type="number" min="0" value={form.price_member} onChange={(e) => setForm({ ...form, price_member: e.target.value })} />
          </div>
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 16, marginTop: 12 }}>
          <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13 }}>
            <input type="checkbox" checked={form.needs_staff} onChange={(e) => setForm({ ...form, needs_staff: e.target.checked })} />
            {t("needs_staff")}
          </label>
          {form.needs_staff && (
            <div style={{ minWidth: 200 }}>
              <label className="muted" style={{ fontSize: 12 }}>{t("staff_title")}</label>
              <input style={{ ...inp, width: "100%" }} maxLength={40} placeholder={t("staff_ph")}
                value={form.staff_title} onChange={(e) => setForm({ ...form, staff_title: e.target.value })} />
            </div>
          )}
          <label style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13 }}>
            <input type="checkbox" checked={form.needs_room} onChange={(e) => setForm({ ...form, needs_room: e.target.checked })} />
            {t("needs_room")}
          </label>
        </div>
        <div style={{ marginTop: 12 }}>
          <label className="muted" style={{ fontSize: 12 }}>{t("options")}</label>
          <textarea style={{ ...inp, width: "100%", minHeight: 60, resize: "vertical" }} placeholder={t("options_ph")}
            value={form.options} onChange={(e) => setForm({ ...form, options: e.target.value })} />
          <div className="muted" style={{ fontSize: 11.5, marginTop: 2 }}>{t("options_hint")}</div>
        </div>
        <div className="muted" style={{ fontSize: 11.5, marginTop: 6 }}>{t("dur_hint")} · {t("tier_hint")}</div>
        <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
          <button className="btn primary small" disabled={busy || !form.name.trim()} onClick={save}>{t("save")}</button>
          {editId && <button className="btn secondary small" onClick={reset}>{t("cancel")}</button>}
        </div>
      </div>

      {/* area filter */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 16 }}>
        {["all", ...AREAS].map((a) => (
          <button key={a} onClick={() => setFilter(a)}
            className={filter === a ? "btn primary small" : "btn secondary small"}>{t(a)}</button>
        ))}
      </div>

      {/* list */}
      {rows == null ? <p className="muted" style={{ marginTop: 16 }}>…</p> : shown.length === 0 ? (
        <div style={{ ...CARD, padding: 20, marginTop: 12, textAlign: "center" }} className="muted">{t("none")}</div>
      ) : (
        <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 8 }}>
          {shown.map((s) => (
            <div key={s.id} style={{ ...CARD, padding: "12px 14px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
                <span style={{ background: AREA_TINT[s.area], color: AREA_FG[s.area], borderRadius: 16, padding: "3px 10px", fontSize: 12, fontWeight: 700 }}>{t(s.area)}</span>
                <div style={{ flex: 1, minWidth: 140 }}>
                  <div style={{ fontWeight: 700 }}>{s.name}{!s.active && <span className="muted" style={{ fontWeight: 400, fontSize: 12 }}> · {t("inactive")}</span>}</div>
                  <div className="muted" style={{ fontSize: 12.5 }}>
                    {s.duration_min ? `${s.duration_min} ${t("min")}` : t("access")}
                    {s.needs_staff ? " · 🧖" : ""}{s.needs_room ? " · 🚪" : ""}
                  </div>
                </div>
                <div style={{ textAlign: "right", fontSize: 13 }}>
                  <div style={{ fontWeight: 700, color: "#27500A" }}>{formatPrice(s.price_public, cur)}</div>
                  <div className="muted" style={{ fontSize: 11.5 }}>
                    {s.price_guest != null ? `${t("p_guest")}: ${formatPrice(s.price_guest, cur)}` : ""}
                    {s.price_guest != null && s.price_member != null ? " · " : ""}
                    {s.price_member != null ? `${t("p_member")}: ${formatPrice(s.price_member, cur)}` : ""}
                  </div>
                </div>
                <div style={{ display: "flex", gap: 8 }}>
                  {s.active && <button className="btn primary small" onClick={() => (bookFor === s.id ? setBookFor(null) : openBook(s))}>{t("sell")}</button>}
                  <button className="btn secondary small" onClick={() => startEdit(s)}>{t("edit")}</button>
                  <button onClick={() => remove(s)} style={{ background: "none", border: "none", color: "#A32D2D", cursor: "pointer", fontSize: 13, fontWeight: 600 }}>{t("del")}</button>
                </div>
              </div>

              {bookFor === s.id && (
                <div style={{ marginTop: 10, borderTop: "1px solid #eef2f2", paddingTop: 10 }}>
                  {receipt ? (
                    <div id="svc-receipt" style={{ maxWidth: 320 }}>
                      <div style={{ fontWeight: 700 }}>{receipt.hotel}</div>
                      <div style={{ fontSize: 13, marginTop: 4 }}>{receipt.service}</div>
                      <table style={{ width: "100%", fontSize: 13, marginTop: 8 }}><tbody>
                        <tr><td>{s.name}</td><td style={{ textAlign: "right" }}>{formatPrice(receipt.subtotal, cur)}</td></tr>
                        {receipt.service_charge > 0 && <tr><td className="muted">{t("r_service")}</td><td style={{ textAlign: "right" }}>{formatPrice(receipt.service_charge, cur)}</td></tr>}
                        {receipt.vat > 0 && <tr><td className="muted">{t("r_vat")} {receipt.vat_pct ? `${receipt.vat_pct}%` : ""}</td><td style={{ textAlign: "right" }}>{formatPrice(receipt.vat, cur)}</td></tr>}
                        <tr style={{ fontWeight: 700, borderTop: "1px solid #ddd" }}><td>{t("r_total")}</td><td style={{ textAlign: "right" }}>{formatPrice(receipt.total, cur)}</td></tr>
                      </tbody></table>
                      <div style={{ marginTop: 10, display: "flex", gap: 8 }}>
                        <button className="btn primary small" onClick={printReceipt}>{t("print")}</button>
                        <button className="btn secondary small" onClick={() => setBookFor(null)}>{t("close_l")}</button>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div style={{ display: "flex", gap: 8, marginBottom: 10, flexWrap: "wrap" }}>
                        <button className={bt === "guest" ? "btn primary small" : "btn secondary small"} onClick={() => setBt("guest")}>{t("bt_guest")}</button>
                        <button className={bt === "member" ? "btn primary small" : "btn secondary small"} onClick={() => setBt("member")}>{t("bt_member")}</button>
                        <button className={bt === "walkin" ? "btn primary small" : "btn secondary small"} onClick={() => setBt("walkin")}>{t("bt_walkin")}</button>
                        <span style={{ marginLeft: "auto", fontWeight: 700, color: "#27500A", alignSelf: "center" }}>{formatPrice(priceFor(s), cur)}</span>
                      </div>
                      {bt === "guest" ? (
                        <div>
                          {resList == null ? <span className="muted" style={{ fontSize: 13 }}>…</span> : resList.length === 0 ? (
                            <div className="muted" style={{ fontSize: 13 }}>{t("no_inhouse")}</div>
                          ) : (() => {
                            const q = gq.trim().toLowerCase();
                            const shown = q
                              ? resList.filter((r) => (r.guest_name || "").toLowerCase().includes(q) || (r.room_name || "").toLowerCase().includes(q))
                              : resList;
                            return (
                              <div style={{ display: "flex", flexDirection: "column", gap: 6, maxWidth: 360 }}>
                                <input style={{ ...inp, width: "100%" }} placeholder={t("search_room_or_name")} value={gq} onChange={(e) => setGq(e.target.value)} />
                                <select style={{ ...inp, width: "100%" }} value={resId} onChange={(e) => setResId(e.target.value)}>
                                  <option value="">{t("pick_guest")}</option>
                                  {shown.map((r) => <option key={r.id} value={r.id}>{r.guest_name}{r.room_name ? ` · ${r.room_name}` : ""} ({t(r.status === "checked_in" ? "bt_guest" : "bt_walkin")})</option>)}
                                </select>
                              </div>
                            );
                          })()}
                        </div>
                      ) : bt === "member" ? (
                        <div>
                          {memList == null ? <span className="muted" style={{ fontSize: 13 }}>…</span> : memList.length === 0 ? (
                            <div className="muted" style={{ fontSize: 13 }}>{t("no_members")}</div>
                          ) : (
                            <select style={{ ...inp, width: "100%", maxWidth: 360 }} value={memId} onChange={(e) => setMemId(e.target.value)}>
                              <option value="">{t("pick_member")}</option>
                              {memList.map((m) => <option key={m.id} value={m.id}>{m.name} · {m.plan_name}</option>)}
                            </select>
                          )}
                        </div>
                      ) : (
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: 8 }}>
                          <input style={inp} placeholder={t("cust_name")} value={cName} onChange={(e) => setCName(e.target.value)} />
                          <input style={inp} placeholder={t("cust_phone")} value={cPhone} onChange={(e) => setCPhone(e.target.value)} />
                          <select style={inp} value={method} onChange={(e) => setMethod(e.target.value)}>
                            <option value="cash">{t("m_cash")}</option>
                            <option value="telebirr">{t("m_telebirr")}</option>
                            <option value="cbe_birr">{t("m_cbe")}</option>
                            <option value="pos">{t("m_pos")}</option>
                          </select>
                          <input style={inp} placeholder={t("cust_company")} value={cCompany} onChange={(e) => setCCompany(e.target.value)} />
                          <input style={inp} placeholder={t("cust_tin")} value={cTin} onChange={(e) => setCTin(e.target.value)} />
                        </div>
                      )}
                      {Array.isArray(s.options) && s.options.length > 0 && (
                        <div style={{ marginTop: 10 }}>
                          <div className="muted" style={{ fontSize: 12, marginBottom: 4 }}>{t("options")}</div>
                          <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
                            {s.options.map((opt) => (
                              <label key={opt} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13 }}>
                                <input type="checkbox" checked={selItems.includes(opt)}
                                  onChange={(e) => setSelItems((cur) => e.target.checked ? [...cur, opt] : cur.filter((x) => x !== opt))} />
                                {opt}
                              </label>
                            ))}
                          </div>
                        </div>
                      )}
                      <div style={{ marginTop: 10, maxWidth: 360 }}>
                        <label className="muted" style={{ fontSize: 12 }}>{t("special_request")}</label>
                        <input style={{ ...inp, width: "100%" }} maxLength={500} placeholder={t("sr_ph")}
                          value={specialReq} onChange={(e) => setSpecialReq(e.target.value)} />
                      </div>
                      {flash && <div style={{ fontSize: 13, color: "#0F6E56", marginTop: 8, fontWeight: 600 }}>{flash}</div>}
                      <div style={{ marginTop: 10, display: "flex", gap: 8 }}>
                        <button className="btn primary small" disabled={bookBusy || (bt === "guest" && !resId) || (bt === "member" && !memId)} onClick={() => doBook(s)}>{t("book_now")}</button>
                        <button className="btn secondary small" onClick={() => setBookFor(null)}>{t("close_l")}</button>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
